import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PropertiesSettings } from '../../../core/configuration/properties-settings';
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import {
  SezioneEconomicaLiquidatiAdapter
} from '../../components/fascicolo/sezione-economica-liquidati-update/sezione-economica-liquidati-adapter';
import { SezioneEsitiResponse } from '../../models/dto/sezione-esiti-response';
import { Esito } from '../../models/esito';
import { FascicoloFull } from '../../models/fascicolo/fascicolo-full';
import { Liquidato } from '../../models/liquidato';
import { SezioneEconomica } from '../../models/sezioni/sezione-economica';
import { Cpa } from '../../models/tipologiche/cpa';
import { Iva } from '../../models/tipologiche/iva';
import { TipoLiquidato } from '../../models/tipologiche/tipo-liquidato';
import { NumericOperationManager } from '../../utils/numeric-operation-manager';
import { BaseForm } from '../base-Form';

@Component({
    selector: 'div [sezione-economica-liquidati-form]',
  templateUrl: 'sezione-economica-liquidati-form.component.html'
})
export abstract class SezioneEconomicaLiquidatiFormComponent extends BaseForm {

  request: Liquidato;
  fondoLiquidatiForm: FormGroup;
  fascicolo: FascicoloFull;
  sezione: SezioneEconomica;
  isViewTerzoPignorato: boolean = false;
  labelLiquidati: string;
  labelLiquidato: string;
  labelLiquidatoInitCap: string;
  labelLiquidazione: string;

  idSezioneEsiti: string;
  urlReadSezioneEsiti: string;
  msgNoBeneficiari: string;

  visibleToggleAssocia: boolean;
  visibleToggleForm: boolean;

  esito: Esito = new Esito();

  // options
  ivaOptions: Iva[] = [];
  cpaOptions: Cpa[] = [];
  esitiList: Esito[]=[];
  // tipoLiquidatoOptions: TipoLiquidato[] = [{id: '1', label: 'Dare', descrizione: '', rimosso: false}, {id: '2', label: 'Avere', descrizione: '', rimosso: false}];

  cpaPerc: number;
  ivaPerc: number;

  abstract getLiquidato(): Liquidato;
  abstract getRequest(request: Liquidato, esito: Esito);

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService) {
    super();
  }

  initRequest() {
    this.request = new SezioneEconomicaLiquidatiAdapter(this.getLiquidato()).liquidato;
    this.ricalcolaImporti(null, null);
    this.impostaLabelLiquidati();
    if (!this.request.tipoLiquidato) {
      this.request.tipoLiquidato = new TipoLiquidato();
      this.request.tipoLiquidato.id = '1';
    }
    this.request.dataLiquidato = new Date().getTime();
  }

  getUrlUpdateEsito(){
    return "/rs/ops/gp/"+ this.fascicolo.praticaBase.tipoPratica.endpoint + "/fasc/" + this.fascicolo.tipoFascicolo.endpoint + "/sez/esiti/{idSezione}/esito";
  }

  associaEsito(esito: Esito){
    this.esito = esito;
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
  }

  readSezioneEsiti(id, url){
    if(id){
      this.operationService.readSezione(url, id).subscribe(response=>{
        this.esitiList = (<SezioneEsitiResponse>response).sezione.esiti.filter(element=>!element.liquidati || element.liquidati.length == 0);
      });
    }
    this.msgNoBeneficiari = 'Non esistono beneficiari da associare.'
  }

  impostaLabelLiquidati() {
    if (PropertiesSettings.listFascicoliChangeLabelLiquidati.find(f => f === this.fascicolo.tipoFascicolo.id)) {
      this.labelLiquidati = PropertiesSettings.labelSommeAssegnate;
      this.labelLiquidato = PropertiesSettings.labelSommaAssegnata;
     this.labelLiquidatoInitCap = PropertiesSettings.labelSommeAssegnateInitCap;
      this.labelLiquidazione = PropertiesSettings.labelLiquidazioneSommaAssegnata;
    }else {
      this.labelLiquidati = PropertiesSettings.labelLiquidati;
      this.labelLiquidato = PropertiesSettings.labelLiquidato;
      this.labelLiquidatoInitCap = PropertiesSettings.labelLiquidatiInitCap;
      this.labelLiquidazione = PropertiesSettings.labelLiquidazione;
    }
  }

  save() {
    this.getRequest(this.request, this.esito);
  }

  populateSelect() {
    if (this.ivaOptions.length === 0) {
      this.helpers.getIva().subscribe(response => this.ivaOptions = response);
    }
    if (this.cpaOptions.length === 0) {
      this.helpers.getCpa().subscribe(response => this.cpaOptions = response);
    }
    this.helpers.getTipiLiquidato().subscribe(response=>{
      this.request.tipoLiquidato=response.tipologiche.find(el=>el.label=="Dare");
    });
  }

  createForm() {
    this.initRequest();
    this.fondoLiquidatiForm = this.campiForm.group({
      // dataLiquidato: [this.request.dataLiquidato, Validators.required],
      // tipoLiquidato: [this.request.tipoLiquidato, Validators.required],
      note: [this.request.note],
      importo: [this.request.importoLiquidato.importo, Validators.required],
      interessi: [this.request.importoLiquidato.interessi],
      sanzioni: [this.request.importoLiquidato.sanzioni],
      // diritti: [this.request.costoGestioneLiquidato.diritti],
      // onorari: [this.request.costoGestioneLiquidato.onorari],
      compenso: [this.request.costoGestioneLiquidato.compenso],
      cpa: [this.request.costoGestioneLiquidato.cpa],
      iva: [this.request.costoGestioneLiquidato.iva],
      flagRitenutaAcconto: [this.request.costoGestioneLiquidato.flagRitenutaAcconto],
      speseRegistrazione: [this.request.altroImportoLiquidato.speseRegistrazione],
      contributoUnificato: [this.request.altroImportoLiquidato.contributoUnificato],
      altroImporto: [this.request.altroImportoLiquidato.altroImporto],
      rimborsoTerzoPignorato: [this.request.altroImportoLiquidato.rimborsoTerzoPignorato],
    });
  }

  initViewToggle() {
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
 if (this.inserimento) {
    this.visibleToggleAssocia = true;
    this.visibleToggleForm = false;
  }
}

  ricalcolaImporti(event: any, tipoPerc: string) {
    let perc = 0;
    if (event && event.target && event.target.selectedIndex) {
      let percId = event.target.selectedIndex;
      if (event.target.options[percId] && event.target.options[percId].label) {
        perc = event.target.options[percId].label;
      }else {
        perc = 0;
      }
      switch (tipoPerc) {
       case 'cpa' :
          this.cpaPerc = perc;
          break;
       case 'iva' :
          this.ivaPerc = perc;
          break;
      }
    } else {
        this.cpaPerc = this.request.costoGestioneLiquidato.cpa ? this.request.costoGestioneLiquidato.cpa.valore  : 0;
        this.ivaPerc = this.request.costoGestioneLiquidato.iva ? this.request.costoGestioneLiquidato.iva.valore  : 0;
    }
  }

  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args);
  }

  getDiff(a: string, b: string) {
    return NumericOperationManager.getDiff(a, b);
  }
}
